declare const GM: unknown;
declare const GM_addElement: unknown;
declare const GM_addStyle: unknown;
declare const GM_addValueChangeListener: unknown;
declare const GM_cookie: unknown;
declare const GM_deleteValue: unknown;
declare const GM_download: unknown;
declare const GM_getResourceText: unknown;
declare const GM_getResourceURL: unknown;
declare const GM_getTab: unknown;
declare const GM_getTabs: unknown;
declare const GM_getValue: unknown;
declare const GM_info: unknown;
declare const GM_listValues: unknown;
declare const GM_log: unknown;
declare const GM_notification: unknown;
declare const GM_openInTab: unknown;
declare const GM_registerMenuCommand: unknown;
declare const GM_removeValueChangeListener: unknown;
declare const GM_saveTab: unknown;
declare const GM_setClipboard: unknown;
declare const GM_setValue: unknown;
declare const GM_unregisterMenuCommand: unknown;
declare const GM_xmlhttpRequest: unknown;
declare const GM_webRequest: unknown;
declare const unsafeWindow: unknown;

export const _GM = /* @__PURE__ */ (() =>
  typeof GM != 'undefined' ? GM : void 0)();
export const _GM_addElement = /* @__PURE__ */ (() =>
  typeof GM_addElement != 'undefined' ? GM_addElement : void 0)();
export const _GM_addStyle = /* @__PURE__ */ (() =>
  typeof GM_addStyle != 'undefined' ? GM_addStyle : void 0)();
export const _GM_addValueChangeListener = /* @__PURE__ */ (() =>
  typeof GM_addValueChangeListener != 'undefined'
    ? GM_addValueChangeListener
    : void 0)();
export const _GM_cookie = /* @__PURE__ */ (() =>
  typeof GM_cookie != 'undefined' ? GM_cookie : void 0)();
export const _GM_deleteValue = /* @__PURE__ */ (() =>
  typeof GM_deleteValue != 'undefined' ? GM_deleteValue : void 0)();
export const _GM_download = /* @__PURE__ */ (() =>
  typeof GM_download != 'undefined' ? GM_download : void 0)();
export const _GM_getResourceText = /* @__PURE__ */ (() =>
  typeof GM_getResourceText != 'undefined' ? GM_getResourceText : void 0)();
export const _GM_getResourceURL = /* @__PURE__ */ (() =>
  typeof GM_getResourceURL != 'undefined' ? GM_getResourceURL : void 0)();
export const _GM_getTab = /* @__PURE__ */ (() =>
  typeof GM_getTab != 'undefined' ? GM_getTab : void 0)();
export const _GM_getTabs = /* @__PURE__ */ (() =>
  typeof GM_getTabs != 'undefined' ? GM_getTabs : void 0)();
export const _GM_getValue = /* @__PURE__ */ (() =>
  typeof GM_getValue != 'undefined' ? GM_getValue : void 0)();
export const _GM_info = /* @__PURE__ */ (() =>
  typeof GM_info != 'undefined' ? GM_info : void 0)();
export const _GM_listValues = /* @__PURE__ */ (() =>
  typeof GM_listValues != 'undefined' ? GM_listValues : void 0)();
export const _GM_log = /* @__PURE__ */ (() =>
  typeof GM_log != 'undefined' ? GM_log : void 0)();
export const _GM_notification = /* @__PURE__ */ (() =>
  typeof GM_notification != 'undefined' ? GM_notification : void 0)();
export const _GM_openInTab = /* @__PURE__ */ (() =>
  typeof GM_openInTab != 'undefined' ? GM_openInTab : void 0)();
export const _GM_registerMenuCommand = /* @__PURE__ */ (() =>
  typeof GM_registerMenuCommand != 'undefined'
    ? GM_registerMenuCommand
    : void 0)();
export const _GM_removeValueChangeListener = /* @__PURE__ */ (() =>
  typeof GM_removeValueChangeListener != 'undefined'
    ? GM_removeValueChangeListener
    : void 0)();
export const _GM_saveTab = /* @__PURE__ */ (() =>
  typeof GM_saveTab != 'undefined' ? GM_saveTab : void 0)();
export const _GM_setClipboard = /* @__PURE__ */ (() =>
  typeof GM_setClipboard != 'undefined' ? GM_setClipboard : void 0)();
export const _GM_setValue = /* @__PURE__ */ (() =>
  typeof GM_setValue != 'undefined' ? GM_setValue : void 0)();
export const _GM_unregisterMenuCommand = /* @__PURE__ */ (() =>
  typeof GM_unregisterMenuCommand != 'undefined'
    ? GM_unregisterMenuCommand
    : void 0)();
export const _GM_xmlhttpRequest = /* @__PURE__ */ (() =>
  typeof GM_xmlhttpRequest != 'undefined' ? GM_xmlhttpRequest : void 0)();
export const _GM_webRequest = /* @__PURE__ */ (() =>
  typeof GM_webRequest != 'undefined' ? GM_webRequest : void 0)();

export const _unsafeWindow = /* @__PURE__ */ (() =>
  typeof unsafeWindow != 'undefined' ? unsafeWindow : void 0)();

export const _monkeyWindow = /* @__PURE__ */ (() => window)();
